module.exports = __webpack_public_path__ + "img/Group7.c729e1cf.svg";